import { getAvatarHexColor, resolveAvatarUrl } from "utils/avatar";

export function asArray(value) {
  return Array.isArray(value) ? value : [];
}

export function makePrefixedTempId(prefix) {
  return `${prefix}${Math.random().toString(16).slice(2)}_${Date.now()}`;
}

export function isPrefixedTempId(value, prefix) {
  return typeof value === "string" && value.startsWith(prefix);
}

export function toNullableId(value) {
  const text = String(value ?? "").trim();
  return text.length ? text : null;
}

export function toNullableInteger(value) {
  const text = String(value ?? "").trim();
  if (!text.length) return null;
  const number = Number(text);
  return Number.isInteger(number) ? number : null;
}

function pickFirstValue(source, keys) {
  for (const key of keys) {
    const value = source?.[key];
    if (value != null && String(value).trim() !== "") return value;
  }
  return null;
}

export function normalizeRosterRows(rows, { idKeys = ["id"], nameKeys = ["nombre"], fallbackName = "Item" } = {}) {
  return asArray(rows)
    .map((row) => {
      const id = pickFirstValue(row, idKeys);
      if (id == null) return null;
      const nombre = pickFirstValue(row, nameKeys) ?? fallbackName;
      return { ...row, id, nombre };
    })
    .filter(Boolean);
}

export function toAvatarSelectItems(rows, { fallbackLabel = "Item" } = {}) {
  return asArray(rows)
    .map((row) => {
      const value = row?.id;
      if (value == null || String(value).trim() === "") return null;
      const label = row?.nombre || fallbackLabel;
      return {
        value: String(value),
        label,
        avatar: resolveAvatarUrl(row),
        color: getAvatarHexColor(value || label),
      };
    })
    .filter(Boolean);
}
